export default {
  htmlIgnoreCSSProperties: [
    'font-family',
    'font-size',
    'color'
  ],
  htmlAllowedStyleProps: [
    'margin',
    'padding',
    'width',
    'border-top'
  ],
};
